<template>
  <div id="app">
    <DataTable></DataTable>
  </div>
</template>

<script>
import DataTable from './components/Table.vue'

export default {
  name: 'App',
  components: {
    DataTable
  },
  data: () => ({
    }),
}
</script>